// existential getter function that looks up
// dot-delimited styles

import {tokens as RadiiTokenType} from '@fuegokit/tokens/dist/ts/atlassian/base/radii'
import {tokens as SizeTokenType} from '@fuegokit/tokens/dist/ts/atlassian/base/size'
import {tokens as TypoTokenType} from '@fuegokit/tokens/dist/ts/atlassian/base/typography'
import {tokens as ColorsTokenType} from '@fuegokit/tokens/dist/ts/atlassian/colors/light'
import {Theme} from '../components/ThemeProvider/ThemeProvider'
import {KeyPaths} from './types/KeyPaths'
import {breakpoints, animation, borderWidths, fontFamily, fonts} from './theme-extensions'

// this is a temporary hand-built type until we migrate @fuegokit/tokens to TS fully and separate colors and shadows there, at the source
// once we do that we won't need to use the partitionColors function in theme-utils and theme-preval
type ShadowTokenType = {
  shadows: {
    elevation: {
      shadow: {
        raised: string
        overflow: {
          default: string
          spread: string
          perimeter: string
        }
        overlay: string
      }
    }
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type TupleIndices<A extends any[]> = A extends [any, ...infer T] ? TupleIndices<T> | T['length'] : never

type Writeable<T> = {-readonly [P in keyof T]: T[P]}

type RadiiType = KeyPaths<RadiiTokenType>
type SizeType = KeyPaths<SizeTokenType>
type TypoType = KeyPaths<TypoTokenType>
type ColorType = `colors.${KeyPaths<ColorsTokenType>}`
type ShadowType = KeyPaths<ShadowTokenType>
type BreakpointsType = `breakpoints.${TupleIndices<Writeable<typeof breakpoints>>}`
type AnimationType = `animation.${KeyPaths<typeof animation>}`
type BorderWidthsType = `borderWidths.${TupleIndices<Writeable<typeof borderWidths>>}`
type FontFamilyType = `fontFamily.${KeyPaths<typeof fontFamily>}`
type FontsType = `fonts.${KeyPaths<typeof fonts>}`

export type FuegokitColorType = ColorType
export type FuegokitThemeTypes =
  | RadiiType
  | SizeType
  | TypoType
  | ColorType
  | BreakpointsType
  | AnimationType
  | BorderWidthsType
  | FontFamilyType
  | FontsType
  | ShadowType

export type FuegokitThemeMapType = {[k: string]: FuegokitThemeTypes}

export const get = (theme: Theme | undefined, token: FuegokitThemeTypes, fallback: string | null) => {
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  const key = token && token.split ? token.split('.') : [token]
  for (let i = 0; i < key.length; i++) {
    theme = theme ? theme[key[i]] : undefined
  }
  return theme === undefined ? fallback : theme
}
export const themeGet =
  (token: FuegokitThemeTypes, fallback = null) =>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (props: any) =>
    get(props.theme, token, fallback)
export default themeGet
